class ReadMoreComponent extends HTMLElement {
    connectedCallback() {

        // Safari thinks it's height 0 without this
        this.style.display = 'block';

        const fullContent = this.innerHTML;

        const minHeightToReadMore = 125;
        if (this.offsetHeight < minHeightToReadMore) {
          return;
        }

        const { 
          moreText = '+ More',
          lessText = '- Less',
        } = this.dataset;

        // Create a wrapper div for the content
        const contentDiv = document.createElement('div');
        contentDiv.classList.add('collapsed', 'seo-text'); // Initially show collapsed content

        const button = document.createElement('button');
        button.classList.add('read-more-btn');
        button.textContent = moreText;

        // Append the content and button to the component
        this.innerHTML = ''; // Clear the existing content
        contentDiv.innerHTML = fullContent; // Add the full content initially
        this.appendChild(contentDiv);
        this.appendChild(button);

        // Add event listener for toggling content
        button.addEventListener('click', () => {
            if (button.textContent === moreText) {
                contentDiv.classList.remove('collapsed');
                contentDiv.classList.add('expanded'); // Use absolute positioning for expanded content
                button.textContent = lessText;
            } else {
                contentDiv.classList.remove('expanded');
                contentDiv.classList.add('collapsed');
                button.textContent = moreText;
            }
        });
    }
}

// Define the web component
customElements.define('read-more', ReadMoreComponent);

